//外部依赖
import { useCallback, useEffect, useRef, useState } from 'react';
import { useInViewport } from 'ahooks';
import { useRouter } from 'next/navigation';
// 图标
import FavoriteIcon from '@/assets/icons/favoriteIcon.svg';
import SuccIcon from '@/assets/icons/succIcon.svg';
import MemberPlus from '@/assets/icons/memberPlusIcon.svg';
import Star from '@/assets/icons/Star-small.svg';
import TimeIcon from '@/assets/icons/Time.svg';
import WishIconProduct from '@/assets/icons/WishIconProduct.svg';

// 接口和ts
import { BizType, followApi, unFollowApi } from '@/apis/dp/service';
import { PreSellStatus, type productData_3 } from '../../index.interface';

import { ProductState } from '../../index.interface';
//内部组件和方法
import CDNImage from '@/components/cdnImage/cdnImage';
import Countdown from '@/components/countdown/index';
import JDIPrice from '@/components/price/index';
import SafeLink from '@/components/SafeLink';
import UKLoadingIcon, { CIRCLE_COLOR_MAP, SIZE_MAP } from '@/components/UKLoadingIcon';
import UKProductSelDrawer from '@/components/UKProductSelDrawer';
import UKToast from '@/components/UKToast/index';
import { safeJsonParse } from '@/utils';
import { addCartUtil } from '@/utils/cartUtils';
import { formatProductLink } from '@/utils/formatProductLink';
import {
  PRODUCT_CARD_EVENT_NAMES,
  PRODUCT_CARD_TYPE,
  productCardBusinessLogger,
} from '@/utils/logger/instance/productCardBusinessLogger';
import OutOfStackController from '@/utils/outofStock/outofStockController';
import {
  comparePrice,
  formatStyle,
  getExptag,
  imgTipsStyle,
  paramsLoggerError,
} from '../../common/utils';
//多语言
import { useTranslation } from '@/i18n/client';
//样式
import style from './style.module.scss';
import { useStores } from '@/models';
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils';

import { mockProps } from '../../mock';
interface PropsType {
  productData: productData_3;
}

export default function ProductCard_3({ productData }: PropsType) {
  const {
    from = '',
    width,
    height,
    skuName,
    skuNameStyle,
    skuImgKeyParams,
    skuImg,
    skuImgStyle,
    skuImgProps,
    skuId,
    realPrice,
    realPriceJDIPriceParams,
    originalPrice,
    originalPriceJDIPriceParams,
    currency,
    languageCode,
    imgTips,
    shouldShowCart,
    onClickCart,
    onAddCartSuccess,
    shouldShowModal = true,
    shouldShowService = false,
    jumpTarget,
    jumpUrl,
    onClickProduct,
    saleTipsDom,
    productLabelDom,
    score,
    scoreStyle,
    marketingStyle_1,
    marketingArray_1 = [],
    marketingStyle_2,
    marketingArray_2 = [],
    shouldShowMoreModel,
    moreModels,
    moreModelsStyle,
    promotions,
    priceStyle,
    saleInfo,
    saleInfoStyle,
    trackingPointParams,
    subscribeType,
    subscribeStatus,
    NotifyCallback,
    shipmentType,
    isWish,
    isShowWish = true,
    productState,
    isMember,
    memberPrice,
    memberPriceDesc,
    memberPriceIcon,
    unitPriceText,
    presellInfo,
    isPromotion,
  } = productData;
  let { containerStyle } = productData;
  //兼容传入宽高的样式
  containerStyle = Object.assign({}, containerStyle);
  if (width !== undefined && width !== null) {
    containerStyle.width = formatStyle(width);
  }
  if (height !== undefined && height !== null) {
    containerStyle.height = formatStyle(height);
  }

  //到手价默认样式
  const defaultRealPriceJDIPriceParams = {
    symbolStyle: { fontSize: '16px' },
    integerStyle: { fontSize: '20px' },
    decimalPointStyle: { fontSize: '20px' },
    decimalPlaceStyle: { fontSize: '20px' },
    containerStyle: {
      display: 'block',
      height: '26px',
      lineHeight: '26px',
      fontWeight: 700,
      fontSize: '16px',
      color:
        productState === ProductState.REMOVED
          ? '#1A1A1A'
          : originalPrice && comparePrice(originalPrice, realPrice)
            ? '#CC0C1C'
            : realPriceJDIPriceParams?.containerStyle?.color,
    },
  };
  //会员价到手价默认样式
  const defaultMemberPriceJDIPriceParams = {
    symbolStyle: { fontSize: '16px' },
    integerStyle: { fontSize: '20px' },
    decimalPointStyle: { fontSize: '20px' },
    decimalPlaceStyle: { fontSize: '20px' },
    containerStyle: {
      display: 'block',
      height: '26px',
      lineHeight: '26px',
      fontWeight: 700,
      color: '#7014CC',
      fontSize: '16px',
    },
  };
  //划线价默认样式
  const defaultOriginalPriceJDIPriceParams = {
    symbolStyle: { fontSize: '16px' },
    integerStyle: { fontSize: '16px' },
    decimalPointStyle: { fontSize: '16px' },
    decimalPlaceStyle: { fontSize: '16px' },
    containerStyle: {
      display: 'block',
      height: '22px',
      lineHeight: '22px',
      fontWeight: 700,
      color: '#1A1A1A',
      fontSize: '16px',
    },
  };

  //处理营销标签富文本
  function expandShowStyle(obj: any) {
    const showStyleObj = safeJsonParse(obj?.showStyle, {});
    return { ...obj, ...showStyleObj };
  }

  const { t } = useTranslation();
  const { cartNumStore } = useStores();
  const router = useRouter();
  const waitingTime = 600; //接口等待时间600ms
  //曝光时长参数
  const productCardRef = useRef<HTMLDivElement>(null); //商卡ref
  const [isVisibleProduct] = useInViewport(productCardRef, {
    rootMargin: `0px 0px -${productCardRef.current?.clientHeight ? productCardRef.current?.clientHeight / 2 : 0}px 0px`,
    threshold: 0,
  }); //监听商卡曝光
  const productExpStart = useRef(0); //曝光开始时间戳

  const cartBtnRef = useRef(null); //加车按钮ref
  const [isVisibleCartBtn] = useInViewport(cartBtnRef, {
    rootMargin: `0px 0px 0px 0px`,
    threshold: 0,
  }); //监听加车按钮曝光
  const cartBtnExpStart = useRef(0); //曝光开始时间戳

  const [isShowProductModal, setIsShowProductModal] = useState(false); // 是否显示选择商品类型弹窗
  const [notifyStatus, setNotifyStatus] = useState(subscribeStatus);

  //心愿单按钮状态
  const [isWished, setIsWished] = useState(isWish || false); //是否添加心愿单
  const [wishLoading, setWishLoading] = useState(false); //心愿单loading
  const [isShowWishLoading, setIsShowWishLoading] = useState(false); //是否显示心愿单Loading按钮
  //购物车按钮状态
  const [cartLoading, setCartLoading] = useState(false); //购物车loading

  // 加车按钮状态管理
  const [addCartButtonState, setAddCartButtonState] = useState({
    text: t('common.btnText.addToCart'), // 按钮文字
    textColor: '#FFFFFF', // 文字颜色
    showIcon: false, // 是否显示图标
    isTransferring: false, // 是否在状态转换中
  });
  //加车按钮动画控制器
  const animationControllerRef = useRef<AbortController | null>(null);

  //订阅按钮定时器
  let timer: any = null;
  const [notifyLoading, setNotifyLoading] = useState(false); //订阅loading
  const [isShowNotifyLoading, setSsShowNotifyLoading] = useState(false); //是否显示订阅loading按钮

  const [group_0, setGroup_0] = useState<any[]>(productLabelDom ? [productLabelDom] : []); //type=0是标题前打标
  const [group_1, setGroup_1] = useState<any[]>([...marketingArray_2]); //type=0是标题前打标
  const [group_2, setGroup_2] = useState<any[]>(saleTipsDom ? [saleTipsDom] : []); //type=0是标题前打标
  const [group_3, setGroup_3] = useState<any[]>([...marketingArray_1]); //type=0是标题前打标
  const [group_4, setGroup_4] = useState<any[]>([]); //type=0是标题前打标
  const [group_6, setGroup_6] = useState<any[]>([]); //type6 图片左上角营销标签，优先级小于 imgTips
  const [group_7, setGroup_7] = useState<any[]>([]); //type=7是品牌标签
  // 预售状态管理
  const [currentPresellStatus, setCurrentPresellStatus] = useState(presellInfo?.preSellStatus);
  // 抢购期结束时间管理
  const [panicBuyingEndTime, setPanicBuyingEndTime] = useState(
    presellInfo?.panicBuyingEndTime ?? 0,
  );
  //处理营销标签富文本
  const getPromotions = () => {
    const group_0: any[] = [];
    const group_1: any[] = [];
    const group_2: any[] = [];
    const group_3: any[] = [];
    const group_4: any[] = [];
    const group_6: any[] = [];
    const group_7: any[] = [];
    promotions?.map((promotion) => {
      promotion = expandShowStyle(promotion);
      //需要屏蔽掉老版本的秒杀倒计时营销标签
      if (promotion.srType === 3) {
        return;
      }
      if (!promotion.endTime && promotion.srType === 5) {
        const dom = (
          <span className={style.UK_rich_warp}>
            <span
              dangerouslySetInnerHTML={{ __html: promotion.richText }}
              key={promotion.text}
              className={style.UK_richText}
              style={{
                color: promotion.richTextColor,
                backgroundColor: promotion.bgColor,
              }}
            ></span>
          </span>
        );
        group_3.push(dom);
      } else if (promotion.endTime && promotion.srType === 5) {
        const dom = (
          <span className={style.UK_rich_warp}>
            <span
              dangerouslySetInnerHTML={{ __html: promotion.richText }}
              key={promotion.text}
              className={style.UK_richText}
              style={{
                color: promotion.richTextColor,
                backgroundColor: promotion.bgColor,
              }}
            ></span>
            <span className={style.UK_countdown_warp}>
              {promotion.middleIcon && (
                <CDNImage
                  style={{ marginRight: '2px' }}
                  src={promotion.middleIcon}
                  width={14}
                  height={14}
                  alt={'countdown'}
                />
              )}
              <Countdown countdown={promotion.endTime} format={promotion?.format}></Countdown>
            </span>
          </span>
        );
        group_3.push(dom);
      } else if (promotion.type === 0) {
        const dom = (
          <span
            dangerouslySetInnerHTML={{ __html: promotion.richText }}
            key={promotion.text}
          ></span>
        );
        group_0.push(dom);
      } else if (promotion.type === 1) {
        const dom = (
          <span
            dangerouslySetInnerHTML={{ __html: promotion.richText }}
            key={promotion.text}
          ></span>
        );
        group_1.push(dom);
      } else if (promotion.type === 2) {
        const dom = (
          <span
            dangerouslySetInnerHTML={{ __html: promotion.richText }}
            key={promotion.text}
          ></span>
        );
        group_2.push(dom);
      } else if (promotion.type === 4) {
        const dom = (
          <span
            dangerouslySetInnerHTML={{ __html: promotion.richText }}
            key={promotion.text}
          ></span>
        );
        group_4.push(dom);
      } else if (promotion.type === 6) {
        const dom = (
          // icon 和 tag 的样式存在差异，icon 优先级高与 tag，和 UI沟通，icon 与 tag 不会同时存在
          <>
            {promotion.icon ? (
              <span className={style.UK_group6_icon}>
                <CDNImage src={promotion.icon} width={24} height={24} />
              </span>
            ) : (
              <span
                className={style.UK_group6_tag}
                dangerouslySetInnerHTML={{ __html: promotion.richText }}
                style={{
                  color: promotion.richTextColor,
                  backgroundColor: promotion.bgColor,
                }}
              ></span>
            )}
          </>
        );
        group_6.push(dom);
      } else if (promotion.type === 7) {
        const dom = (
          <span
            dangerouslySetInnerHTML={{ __html: promotion.richText }}
            key={promotion.text}
            style={{
              color: promotion.richTextColor,
              backgroundColor: promotion.bgColor,
            }}
          ></span>
        );
        group_7.push(dom);
      }
    });
    setGroup_0(group_0);
    setGroup_1(group_1);
    setGroup_2(group_2);
    setGroup_3(group_3);
    setGroup_4(group_4);
    setGroup_6(group_6);
    setGroup_7(group_7);
  };

  //商卡元素曝光埋点
  useEffect(() => {
    //判断商卡元素是否进入视区
    if (isVisibleProduct) {
      //开始计时
      if (!productExpStart.current) {
        productExpStart.current = new Date().getTime();
      }
    } else {
      exposeProduct();
    }
  }, [isVisibleProduct]);

  //加车按钮元素曝光埋点
  useEffect(() => {
    //判断商卡元素是否进入视区
    if (isVisibleCartBtn) {
      //开始计时
      if (!cartBtnExpStart.current) {
        cartBtnExpStart.current = new Date().getTime();
      }
    } else {
      exposeCartBtn();
    }
  }, [isVisibleCartBtn]);

  //曝光时长的二次曝光事件
  const exposeProduct = () => {
    if (productExpStart.current) {
      if (trackingPointParams?.productExpConfig) {
        const { event_id, json_param }: any = trackingPointParams.productExpConfig;
        //判断是否有event_id，json_param中是否包含了曝光时长的参数，如果有则进行二次曝光，如果没有则不曝光。
        if (event_id && Object.prototype.hasOwnProperty.call(json_param, 'expotime')) {
          json_param.expotime = String(new Date().getTime() - productExpStart.current);
          eventTrackingUtils.submitExp({ event_id, json_param: json_param });
        }
      }
      //二次曝光完成后，清零开始时间
      productExpStart.current = 0;
    }
  };

  //曝光时长的二次曝光事件
  const exposeCartBtn = () => {
    if (cartBtnExpStart.current) {
      if (trackingPointParams?.cartExpConfig) {
        const { event_id, json_param }: any = trackingPointParams.cartExpConfig;
        //判断是否有event_id，json_param中是否包含了曝光时长的参数，如果有则进行二次曝光，如果没有则不曝光。
        if (event_id && Object.prototype.hasOwnProperty.call(json_param, 'expotime')) {
          json_param.expotime = String(new Date().getTime() - cartBtnExpStart.current);
          eventTrackingUtils.submitExp({ event_id, json_param: json_param });
        }
      }
      //二次曝光完成后，清零开始时间
      cartBtnExpStart.current = 0;
    }
  };

  // 组件卸载时清理动画
  useEffect(() => {
    const handlePageHide = () => {
      // 触发expose逻辑
      exposeProduct();
      exposeCartBtn();
    };
    //兼容safari浏览器
    window.addEventListener('beforeunload', handlePageHide);
    return () => {
      // 清理事件监听器
      window.removeEventListener('beforeunload', handlePageHide);
      exposeProduct();
      exposeCartBtn();
      if (animationControllerRef.current) {
        animationControllerRef.current.abort();
      }
    };
  }, []);

  // 异步延迟函数，支持中断
  const sleep = useCallback((ms: number, signal?: AbortSignal): Promise<void> => {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(resolve, ms);
      signal?.addEventListener('abort', () => {
        clearTimeout(timeout);
        reject(new Error('Animation aborted'));
      });
    });
  }, []);

  // 执行按钮动画
  const executeButtonAnimation = useCallback(async () => {
    // 取消之前的动画
    if (animationControllerRef.current) {
      animationControllerRef.current.abort();
    }
    animationControllerRef.current = new AbortController();
    const { signal } = animationControllerRef.current;
    try {
      // 阶段1：文字变黑
      setAddCartButtonState((prev) => ({ ...prev, textColor: '#1a1a1a' }));
      await sleep(150, signal);
      // 阶段2：显示成功状态
      setAddCartButtonState((prev) => ({
        ...prev,
        textColor: '#FFFFFF',
        text: t('common.btnText.Added'),
        showIcon: true,
      }));
      await sleep(1000, signal);
      // 阶段3：文字变黑，隐藏图标
      setAddCartButtonState((prev) => ({ ...prev, textColor: '#1a1a1a', showIcon: false }));
      await sleep(150, signal);
      // 阶段4：恢复初始状态
      setAddCartButtonState({
        text: t('common.btnText.addToCart'),
        textColor: '#FFFFFF',
        showIcon: false,
        isTransferring: false,
      });
    } catch (error) {
      // 动画被取消，不需要处理
      console.log('Button animation was cancelled');
    }
  }, [sleep, t]);

  //处理营销标签富文本
  useEffect(() => {
    if (promotions && promotions.length > 0) {
      getPromotions();
    }
  }, [promotions]);

  //sgm监控埋点
  useEffect(() => {
    if (paramsLoggerError(productData, PRODUCT_CARD_TYPE.TYPE_3)) {
      const { params_error, message }: any = paramsLoggerError(
        productData,
        PRODUCT_CARD_TYPE.TYPE_3,
      );
      //sgm监控，商卡入参错误
      productCardBusinessLogger({
        eventName: PRODUCT_CARD_EVENT_NAMES.PARAMS_ERROR,
        message,
        category: {
          params_error,
        },
        status: false,
      });
    }
  }, [productData]);

  //点击ViewDetails事件
  const handleViewDetailsClick = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    router.push(formatProductLink(skuId, skuName));
  };

  //点击商卡事件
  const handleProductClick = async (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    if (trackingPointParams && trackingPointParams.productClickPoint) {
      trackingPointParams.productClickPoint();
    }
    //sgm监控，商卡点击事件
    productCardBusinessLogger({
      eventName: PRODUCT_CARD_EVENT_NAMES.PRODUCT_CARD_CLICK,
      message: {
        from,
        type: PRODUCT_CARD_TYPE.TYPE_3,
        mainSkuId: skuId,
        jumpUrl: jumpUrl ? jumpUrl : skuImg || '',
      },
    });
    // 检查 onClickProduct 是否存在并且是一个函数
    if (onClickProduct && typeof onClickProduct === 'function') {
      onClickProduct(productData);
    } else {
      //如果不加这个setTimeout的话，上面的埋点和sgm就没法全都执行
      if (jumpUrl) {
        setTimeout(() => {
          window.location.href = jumpUrl;
        }, 100);
      } else {
        router.push(formatProductLink(skuId, skuName));
      }
    }
  };

  //点击购物车事件
  const handleCartClick = (e: any, productData: productData_3) => {
    e.preventDefault();
    e.stopPropagation();

    //无货下架不能加车
    if (cartLoading || productState !== ProductState.IN_STOCK) {
      return;
    }

    //sgm监控，加车点击事件
    productCardBusinessLogger({
      eventName: PRODUCT_CARD_EVENT_NAMES.ADD_CART_BUTTON_CLICK,
      message: {
        from,
        type: PRODUCT_CARD_TYPE.TYPE_3,
        mainSkuId: skuId,
      },
    });

    if (trackingPointParams && trackingPointParams.cartClickPoint) {
      trackingPointParams.cartClickPoint();
    }

    // 检查 onClickCart 是否存在并且是一个函数
    if (onClickCart && typeof onClickCart === 'function') {
      onClickCart(productData);
    } else {
      //加车时是否展示规格弹层
      if (shouldShowModal) {
        setIsShowProductModal(true);
      } else {
        //直接加车
        loadAddCart({ skuId });
      }
    }
  };

  //调用加车方法
  const loadAddCart = ({ skuId }: any) => {
    if (addCartButtonState.isTransferring) {
      return;
    }

    setAddCartButtonState((prev) => ({ ...prev, isTransferring: true }));
    let addCartTimer: NodeJS.Timeout | null = null;
    addCartTimer = setTimeout(() => {
      setCartLoading(true);
    }, 600);

    addCartUtil([{ skuId, num: '1' }], false, shipmentType, true)
      .then((res) => {
        setCartLoading(false);
        if (addCartTimer) {
          clearTimeout(addCartTimer);
        }
        if (trackingPointParams && trackingPointParams.addCartPoint) {
          trackingPointParams.addCartPoint();
        }
        if (res?.result?.code === '200') {
          // 更新购物车数量
          cartNumStore.updateCartNum(res?.result?.data);
          //加车接口调用成功回调方法
          if (onAddCartSuccess && typeof onAddCartSuccess === 'function') {
            onAddCartSuccess(productData);
          }
          executeButtonAnimation();
        } else {
          UKToast.show({
            content: res?.result?.msg || t('cart.addCartWarning'), // 弹窗内容
            icon: 'warning', // 可选：success, fail, loading, warn, info，影响图标
          });
        }
      })
      .catch((err) => {
        if (addCartTimer) {
          clearTimeout(addCartTimer);
        }
        setCartLoading(false);
      });
  };
  //关闭规格弹窗
  const handleClose = () => {
    setIsShowProductModal(false);
  };
  //点击订阅按钮
  const handleNotify = (e: any, skuId: string) => {
    e.preventDefault();
    e.stopPropagation();
    if (notifyLoading || notifyStatus !== 0) {
      return;
    }
    //sgm监控，通知点击事件
    productCardBusinessLogger({
      eventName: PRODUCT_CARD_EVENT_NAMES.NOTIFY_BUTTON_CLICK,
      message: {
        from,
        type: PRODUCT_CARD_TYPE.TYPE_3,
        mainSkuId: skuId,
        notifyStatus: notifyStatus || '',
      },
    });
    const skuIds = [skuId];
    setNotifyLoading(true);
    timer = setTimeout(() => {
      setSsShowNotifyLoading(true);
    }, waitingTime);
    OutOfStackController.getInstance().openOutOfStockDialog(
      skuIds,
      notifySuccess,
      notifyFail,
      notifyClose,
    );
  };
  //订阅成功回调
  const notifySuccess = () => {
    clearTimeout(timer);
    setNotifyLoading(false);
    setSsShowNotifyLoading(false);
    NotifyCallback && NotifyCallback(true);
    setNotifyStatus(1);
  };
  //订阅失败回调
  const notifyFail = () => {
    clearTimeout(timer);
    setNotifyLoading(false);
    setSsShowNotifyLoading(false);
    NotifyCallback && NotifyCallback(false);
  };
  //订阅弹窗关闭
  const notifyClose = () => {
    clearTimeout(timer);
    setNotifyLoading(false);
    setSsShowNotifyLoading(false);
    NotifyCallback && NotifyCallback(false);
  };

  //点击心愿单事件
  const handleClickWish = async (e: any) => {
    e.stopPropagation();
    if (wishLoading) {
      return;
    }
    //sgm监控，通知点击事件
    productCardBusinessLogger({
      eventName: PRODUCT_CARD_EVENT_NAMES.WISH_BUTTON_CLICK,
      message: {
        from,
        type: PRODUCT_CARD_TYPE.TYPE_3,
        mainSkuId: skuId,
        isWished,
      },
    });
    //点击收藏埋点
    if (trackingPointParams && trackingPointParams.wishClickPoint) {
      trackingPointParams?.wishClickPoint(isWished ? '2' : '1');
    }
    //开始计时
    setWishLoading(true); //开始Loading
    //超过600毫米，展示loading
    const timer = setTimeout(() => {
      setIsShowWishLoading(true);
    }, waitingTime);
    //判断当前是否添加心愿单
    if (isWished) {
      const res = await unFollowApi({ bizIds: skuId, bizType: BizType.PRODUCT });
      if (res?.code === '200') {
        setIsWished(false);
      } else {
        UKToast.show({
          content: res?.msg || t('common.message.systemError'), // 弹窗内容
          icon: 'error', // 可选：success, fail, loading, warn, info，影响图标
        });
      }
    } else {
      const res = await followApi({ bizIds: skuId, bizType: BizType.PRODUCT });
      if (res?.code === '200') {
        setIsWished(true);
      } else {
        UKToast.show({
          content: res?.msg || t('common.message.systemError'), // 弹窗内容
          icon: 'error', // 可选：success, fail, loading, warn, info，影响图标
        });
      }
    }
    clearTimeout(timer);
    setIsShowWishLoading(false);
    setWishLoading(false);
  };

  // 判断是否是数字
  const isNumber = (value: any): boolean => {
    return typeof value === 'number' && !isNaN(value);
  };

  // 是否是预售活动且预约期
  const isPreSellAndReservePeriod = () => {
    return (
      currentPresellStatus &&
      [
        PreSellStatus.WAIT_RESERVE,
        PreSellStatus.RESERVING,
        PreSellStatus.WAIT_PANIC_BUYING,
      ].includes(currentPresellStatus)
    );
  };
  const isMemberPriceLessThanRealPrice = () => {
    return realPrice && memberPrice && Number(memberPrice) < Number(realPrice);
  };

  return (
    <div
      className={`sgm_pc ${style.UK_product_card} ${style[productState]}`}
      style={containerStyle}
      ref={productCardRef}
      key={skuId}
      exptag={getExptag('exptag', trackingPointParams, 'productExpConfig')}
      data-exptag-config={getExptag('config', trackingPointParams, 'productExpConfig')}
      data-exptag-json-param={getExptag('json-param', trackingPointParams, 'productExpConfig')}
      data-exptag-event-param={getExptag('event-param', trackingPointParams, 'productExpConfig')}
    >
      <SafeLink
        href={jumpUrl ? jumpUrl : formatProductLink(skuId, skuName)}
        target={jumpTarget}
        onClick={handleProductClick}
      >
        {/* 商品图片 */}
        <div className={style.UK_image_wrapper}>
          <CDNImage
            {...skuImgProps}
            style={skuImgStyle}
            className={`${style.UK_skuImg} ${
              productState !== ProductState.IN_STOCK &&
              productState !== ProductState.PRE_SALE &&
              !isPreSellAndReservePeriod()
                ? style.op50
                : ''
            }`}
            src={(skuImgKeyParams ? skuImgKeyParams?.imgUrlKey : skuImg) as string}
            width={skuImgKeyParams?.width || 240}
            height={skuImgKeyParams?.height || 240}
            alt={skuName}
            onError={() =>
              productCardBusinessLogger({
                eventName: PRODUCT_CARD_EVENT_NAMES.MAIN_IMAGE_LOAD_ERROR,
                message: {
                  from,
                  type: PRODUCT_CARD_TYPE.TYPE_3,
                  mainSkuId: skuId,
                  imageUrl: skuImgKeyParams ? skuImgKeyParams?.imgUrlKey : skuImg || '',
                },
              })
            }
          />
          {/* 商品图片背景及hover遮罩 */}
          <div className={style.UK_mask}></div>
          {imgTips && imgTips.tipDom ? (
            <span className={style.UK_imgTips} style={imgTipsStyle(imgTips.position)}>
              {imgTips.tipDom}
            </span>
          ) : (
            /* group_6 标签 - 优先级小于 imgTips，最多展示两个 */
            group_6.length > 0 &&
            productState !== ProductState.OUT_OF_STICK &&
            productState !== ProductState.REMOVED && (
              <div className={style.UK_group6_wrapper}>
                {group_6.slice(0, 2).map((item: JSX.Element) => item)}
              </div>
            )
          )}
        </div>
      </SafeLink>
      {/* 多规格展示 */}
      {shouldShowMoreModel && moreModels && moreModels.length > 0 && (
        <div className={style.UK_moreModel_wrapper} style={moreModelsStyle}>
          {moreModels.map((item, index) => {
            if (index < 4) {
              return (
                <SafeLink
                  className={style.UK_moreModel}
                  href={formatProductLink(item.wareId)}
                  key={item.wareId}
                >
                  <CDNImage src={item.imageUrl as string} width={40} height={40} alt={skuName} />
                  <div className={style.UK_mask}></div>
                </SafeLink>
              );
            } else if (index === 4) {
              return moreModels.length > 5 ? (
                <span key={item.wareId} className={style.UK_moreModelNum}>
                  +{moreModels.length < 103 ? moreModels.length - 4 : 99}
                </span>
              ) : (
                <SafeLink
                  className={style.UK_moreModel}
                  key={item.wareId}
                  href={formatProductLink(moreModels.length > 5 ? skuId : item.wareId)}
                >
                  <CDNImage src={item.imageUrl as string} width={40} height={40} alt={skuName} />
                  <div className={style.UK_mask}></div>
                </SafeLink>
              );
            }
          })}
        </div>
      )}

      {/* 加车按钮楼层 */}
      {shouldShowCart && (
        <div className={style.UK_AddCart_wrapper}>
          {
            // 缺货订阅按钮
            productState !== ProductState.IN_STOCK && subscribeType === 0 ? (
              <button
                className={`${notifyStatus === 0 ? style.UK_Notify : style.UK_Notify_hidden}`}
                onClick={(e) => handleNotify(e, skuId)}
              >
                {notifyLoading && isShowNotifyLoading ? (
                  <UKLoadingIcon
                    className={style.UK_btnLoading}
                    type={CIRCLE_COLOR_MAP.BLACK}
                    size={SIZE_MAP.SIZE_24}
                  />
                ) : (
                  t(`${notifyStatus === 0 ? 'outofstock.NotifyMe' : 'outofstock.WellNotifyYou'}`)
                )}
              </button>
            ) : // 是否是预售、新人
            isPromotion || productState === ProductState.PRE_SALE ? (
              <button
                className={style.UK_viewDetails}
                onClick={(e: any) => handleViewDetailsClick(e)}
              >
                {t('common.btnText.viewDetails')}
              </button>
            ) : // 是否预约为预约期
            isPreSellAndReservePeriod() ? (
              // 是否已预约
              presellInfo?.userReserve ? (
                <button className={style.UK_Button_Reserved}>{t('common.btnText.reserved')}</button>
              ) : (
                // 未预约展示查看详情
                <button
                  className={style.UK_viewDetails}
                  onClick={(e: any) => handleViewDetailsClick(e)}
                >
                  {t('common.btnText.viewDetails')}
                </button>
              )
            ) : (
              // 加车按钮
              <button
                ref={cartBtnRef}
                className={`${style.UK_AddCart} ${
                  productState !== ProductState.IN_STOCK ? style.UK_unAddCart : ''
                }`}
                onClick={(e: any) => handleCartClick(e, productData)}
                exptag={getExptag('exptag', trackingPointParams, 'cartExpConfig')}
                data-exptag-config={getExptag('config', trackingPointParams, 'cartExpConfig')}
                data-exptag-json-param={getExptag(
                  'json-param',
                  trackingPointParams,
                  'cartExpConfig',
                )}
                data-exptag-event-param={getExptag(
                  'event-param',
                  trackingPointParams,
                  'cartExpConfig',
                )}
              >
                {cartLoading ? (
                  <UKLoadingIcon className={style.UK_btnLoading} size={SIZE_MAP.SIZE_24} />
                ) : (
                  <span className={style.UK_addCartWrapper}>
                    <SuccIcon
                      className={`${style.UK_addCartIcon} ${
                        addCartButtonState.showIcon ? style.visible : style.hidden
                      }`}
                    />
                    <span
                      style={{ color: addCartButtonState.textColor }}
                      className={style.UK_addCartText}
                    >
                      {addCartButtonState.text}
                    </span>
                  </span>
                )}
              </button>
            )
          }
          {isShowWish && (
            <button
              className={style.UK_WishIcon_wrap}
              onClick={handleClickWish}
              exptag={getExptag('exptag', trackingPointParams, 'wishExpConfig')}
              data-exptag-config={getExptag('config', trackingPointParams, 'wishExpConfig')}
              data-exptag-json-param={getExptag('json-param', trackingPointParams, 'wishExpConfig')}
              data-exptag-event-param={getExptag(
                'event-param',
                trackingPointParams,
                'wishExpConfig',
              )}
            >
              {wishLoading && isShowWishLoading ? (
                <UKLoadingIcon
                  className={style.UK_WishLoading}
                  size={SIZE_MAP.SIZE_24}
                  type={CIRCLE_COLOR_MAP.BLACK}
                />
              ) : isWished ? (
                <FavoriteIcon className={style.UK_FavoriteIcon} width={24} height={24} />
              ) : (
                <WishIconProduct className={style.UK_WishIcon} width={24} height={24} />
              )}
            </button>
          )}
        </div>
      )}
      <SafeLink
        href={jumpUrl ? jumpUrl : formatProductLink(skuId, skuName)}
        target={jumpTarget}
        onClick={handleProductClick}
        className={style.UK_content_wrapper}
      >
        {/* 商品名称 */}
        <div className={style.UK_name_wrapper} style={skuNameStyle}>
          <div className={style.UK_name_box}>
            {/* 品牌营销标签 */}
            {group_7.length > 0
              ? group_7.map((item: JSX.Element, i: number) => {
                  return (
                    <span key={i} className={style.UK_brandName}>
                      <span className={style.UK_brandName_text}>{item}</span>
                      <span className={style.UK_brandName_line} />
                    </span>
                  );
                })
              : null}
            {/* 商品标签 */}
            {group_0.length > 0 ? (
              <span className={style.UK_productLabelDom}>{group_0[0]}</span>
            ) : null}
            <span className={style.UK_name}>{skuName}</span>
          </div>
        </div>
        {saleInfo && (
          <div className={style.UK_saleInfo} style={saleInfoStyle}>
            {saleInfo}
          </div>
        )}
        {/* 商品名称下评分 */}
        {score || group_4.length > 0 ? (
          <div className={style.UK_score} style={scoreStyle}>
            {score ? (
              <span className={style.UK_star}>
                <Star className={style.UK_starIcon}></Star>
                {score}
              </span>
            ) : null}
            {group_4.length > 0 ? <span className={style.UK_saleNum}>{group_4[0]}</span> : null}
          </div>
        ) : null}

        {/* 商品名称下营销标签 */}
        {group_3.length > 0
          ? group_3.map((item: JSX.Element, i: number) => {
              return (
                <div className={style.UK_activityRow} key={i} style={marketingStyle_1}>
                  {item}
                </div>
              );
            })
          : null}

        {/* 预约信息 */}
        {presellInfo && currentPresellStatus !== PreSellStatus.PANIC_BUYING_END && (
          <div className={style.UK_presell_wrapper}>
            <span className={style.UK_presell_tag_warp}>
              {presellInfo.preSellLabels?.map((item: string) => {
                return (
                  <span className={style.UK_presell_tag_item} key={item}>
                    {item}
                  </span>
                );
              })}
            </span>
            <div className={style.UK_presell_time_wrap}>
              <TimeIcon />
              {/* 预约期和抢购期文案及时间展示 */}
              <span className={style.UK_presell_time_text}>
                {/* 预约期 */}
                {isPreSellAndReservePeriod() && presellInfo.startTimeFormat && (
                  <span>
                    {/* 大于24（60*60*24）小时，展示预约期文案 */}
                    {presellInfo.panicBuyingStartTime > 86400 &&
                      `${presellInfo.startTimeFormat} ${presellInfo.panicBuyingStartTimeStr}`}
                    {/* 小于24（60*60*24）小时，展示倒计时组件 */}
                    {presellInfo.panicBuyingStartTime < 86400 && (
                      <>
                        {presellInfo.startTimeFormat}
                        <Countdown
                          countdown={presellInfo.panicBuyingStartTime * 1000}
                          format='HH:mm:ss'
                          style={{ marginLeft: '4px' }}
                          onEnd={() => {
                            // 预约期倒计时结束后，进入抢购期
                            setCurrentPresellStatus(PreSellStatus.PANIC_BUYING);
                            // 重置抢购期结束时间
                            if (
                              isNumber(presellInfo.panicBuyingEndTime) &&
                              isNumber(presellInfo.panicBuyingStartTime)
                            ) {
                              if (
                                presellInfo.panicBuyingEndTime - presellInfo.panicBuyingStartTime >
                                0
                              ) {
                                setPanicBuyingEndTime(
                                  presellInfo.panicBuyingEndTime - presellInfo.panicBuyingStartTime,
                                );
                              } else {
                                setCurrentPresellStatus(PreSellStatus.PANIC_BUYING_END);
                              }
                            }
                          }}
                        />
                      </>
                    )}
                  </span>
                )}
                {/* 抢购期 */}
                {currentPresellStatus &&
                  [PreSellStatus.PANIC_BUYING].includes(currentPresellStatus) &&
                  presellInfo.endTimeFormat && (
                    <span>
                      {/* 大于24（60*60*24）小时，展示预约期文案 */}
                      {panicBuyingEndTime > 86400 &&
                        `${presellInfo.endTimeFormat} ${presellInfo.panicBuyingEndTimeStr}`}
                      {/* 小于24（60*60*24）小时，展示倒计时组件 */}
                      {panicBuyingEndTime < 86400 && (
                        <>
                          {presellInfo.endTimeFormat}
                          <Countdown
                            countdown={panicBuyingEndTime * 1000}
                            format='HH:mm:ss'
                            onEnd={() => {
                              setCurrentPresellStatus(PreSellStatus.PANIC_BUYING_END);
                            }}
                            style={{ marginLeft: '4px' }}
                          />
                        </>
                      )}
                    </span>
                  )}
              </span>
            </div>
          </div>
        )}

        {/* 商品价格+ 营销标签 */}
        <div className={style.UK_price_wrapper} style={priceStyle}>
          <div className={style.UK_price}>
            {/* 到手价格 */}
            {(productState === ProductState.IN_STOCK || productState === ProductState.PRE_SALE) &&
            isMember &&
            memberPrice &&
            isMemberPriceLessThanRealPrice() ? (
              <div className={style.UK_memberPrice}>
                {memberPriceIcon ? (
                  <CDNImage
                    alt={memberPriceDesc || 'plusPrice'}
                    className={style.UK_member_icon}
                    src={memberPriceIcon}
                    width={72}
                    height={40}
                  />
                ) : (
                  <MemberPlus className={style.UK_member_icon} width={36} height={20} />
                )}
                <JDIPrice
                  locale={languageCode}
                  currency={currency || ''}
                  price={memberPrice}
                  uiType={1}
                  {...defaultMemberPriceJDIPriceParams}
                />
              </div>
            ) : (
              <div className={style.UK_realPrice}>
                <JDIPrice
                  locale={languageCode}
                  currency={currency || ''}
                  price={realPrice}
                  uiType={1}
                  {...defaultRealPriceJDIPriceParams}
                  {...realPriceJDIPriceParams}
                />
              </div>
            )}
            {/* 划线价 */}
            {originalPrice &&
              comparePrice(
                originalPrice,
                isMember && memberPrice && isMemberPriceLessThanRealPrice()
                  ? memberPrice
                  : realPrice,
              ) && (
                <div className={style.UK_originalPrice}>
                  <JDIPrice
                    locale={languageCode}
                    currency={currency || ''}
                    price={originalPrice}
                    uiType={2}
                    lineThrough
                    {...defaultOriginalPriceJDIPriceParams}
                    {...originalPriceJDIPriceParams}
                  />
                </div>
              )}
          </div>
          {originalPrice &&
            comparePrice(
              originalPrice,
              isMember && memberPrice && isMemberPriceLessThanRealPrice() ? memberPrice : realPrice,
            ) &&
            group_2.length > 0 && <div className={style.UK_saleTipsDom}>{group_2[0]}</div>}
        </div>
        {/* 单位价格 */}
        {unitPriceText && <div className={style.UK_unit_price}>{unitPriceText}</div>}
        {/* 会员价 */}
        {(productState === ProductState.IN_STOCK || productState === ProductState.PRE_SALE) &&
          memberPrice &&
          !isMember &&
          isMemberPriceLessThanRealPrice() && (
            <div className={style.UK_member_price_wrapper}>
              {memberPriceIcon ? (
                <CDNImage
                  alt={memberPriceDesc || 'plusPrice'}
                  className={style.UK_member_icon}
                  src={memberPriceIcon}
                  width={72}
                  height={40}
                />
              ) : (
                <MemberPlus className={style.UK_member_icon} width={36} height={20} />
              )}
              <span className={style.UK_member_text}> {memberPriceDesc} </span>
              <JDIPrice
                locale={languageCode}
                currency={currency || ''}
                price={memberPrice}
                uiType={2}
                containerStyle={{
                  fontSize: '14px',
                  height: '20px',
                  lineHeight: '20px',
                  fontWeight: 700,
                  color: '#7014CC',
                }}
              />
            </div>
          )}
        {/* 底部营销标签 */}
        {group_1.length > 0
          ? group_1.map((item: JSX.Element, i: number) => {
              return (
                <div className={style.UK_activityRow} key={i} style={marketingStyle_2}>
                  {item}
                </div>
              );
            })
          : null}
        {/* 无货和下架文案 */}
        {productState !== ProductState.IN_STOCK && !isPreSellAndReservePeriod() && (
          <div className={style.UK_OutOfStockText}>
            {t(
              productState === ProductState.OUT_OF_STICK
                ? 'common.productStatus.outOfStock'
                : productState === ProductState.REMOVED
                  ? 'common.productStatus.removed'
                  : '',
            )}
          </div>
        )}
      </SafeLink>
      <UKProductSelDrawer
        skuId={String(skuId)}
        triggerOpen={isShowProductModal}
        handleClose={handleClose}
        updateItemData={loadAddCart}
        isShowService={shouldShowService}
      />
    </div>
  );
}
